import type { CampaignViewDto } from '@/types/campaign'
import { ScheduleXCalendar } from '@/components/calendar/ScheduleXCalendar'

interface Props {
  campaign: CampaignViewDto
  clientCompanyId: string
}

export function CampaignCalendarTab({ campaign, clientCompanyId }: Props) {
  return (
    <div className="-m-6">
      <ScheduleXCalendar
        clientCompanyId={clientCompanyId}
        workspaceId={campaign.WorkspaceId}
        campaignId={campaign.Id}
      />
    </div>
  )
}
